export enum TellentDevFlag {
  OneBilling = 'one_billing_released',
  UnifiedGroups = 'unified_groups',
  UnifiedDepartments = 'unified_departments',
  AppShell = 'app_shell',
  OneSettings = 'one_settings',
}

export type TellentDevFlagsMap = Record<TellentDevFlag, boolean>;

export type DevFlagsFetchResponse = {
  data: TellentDevFlag[];
};
